import { FormAction, FormState } from './types';

export const initialState: FormState = {
  values: {},
  errors: {},
  touched: {},
  submitCount: 0,
  isSubmitting: false,
};

export function formReducer(state: FormState, action: FormAction): FormState {
  switch (action.type) {
    case 'fieldChanged':
      return {
        ...state,
        values: { ...state.values, [action.id]: action.value },
      };
    case 'fieldBlurred':
      return { ...state, touched: { ...state.touched, [action.id]: true } };
    case 'setErrors':
      return { ...state, errors: action.errors };
    case 'submitting':
      return { ...state, isSubmitting: action.value };
    case 'incrementSubmit':
      return { ...state, submitCount: state.submitCount + 1 };
    case 'reset':
      return { ...initialState, ...action.next };
    default:
      return state;
  }
}
